const LAUNCH_COMPANY_STORAGE_KEY = "studies.launchRequestedCompanyId";

export function setLaunchRequestedCompanyId(companyId: string): void {
  const id = companyId?.trim();
  if (!id || typeof sessionStorage === "undefined") {
    return;
  }
  try {
    sessionStorage.setItem(LAUNCH_COMPANY_STORAGE_KEY, id);
  } catch {
    /* ignore quota / private mode */
  }
}

export function getLaunchRequestedCompanyId(): string | null {
  if (typeof sessionStorage === "undefined") {
    return null;
  }
  try {
    return sessionStorage.getItem(LAUNCH_COMPANY_STORAGE_KEY)?.trim() || null;
  } catch {
    return null;
  }
}

export function clearLaunchRequestedCompanyId(): void {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  try {
    sessionStorage.removeItem(LAUNCH_COMPANY_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
